<zeusm-info-dialog-content [title]="errorText" status="failed">
  <div class="support-note" afterTitle>
    <fu-icon iconName="information-circle" size="16" />
    <div class="text">
      {{ 'common.contactSupport.question' | translate }}
      <a
        class="link"
        [href]="supportUrl"
        target="_blank"
        rel="noopener noreferrer">
        {{ 'common.contactSupport.link' | translate }}
      </a>
    </div>
  </div>
</zeusm-info-dialog-content>
